import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DASHBOARD } from '@env';

@Injectable()
export class DashboardProvider {

  constructor(public http: HttpClient) {
  }

  getPreguntas(area: string, equipo: string, jugador: string, campania: string = null): Promise<any> {
    if(campania) {
      return this.http.get( `${DASHBOARD.ESTADISTICAS_PREGUNTAS}${area}/${equipo}/${jugador}/${campania}` ).toPromise();
    }
    return this.http.get( `${DASHBOARD.ESTADISTICAS_PREGUNTAS}${area}/${equipo}/${jugador}` ).toPromise();
  }
  getRetos(area: string, equipo: string, jugador: string): Promise<any> {
    return this.http.get( `${DASHBOARD.ESTADISTICAS_RETOS}${area}/${equipo}/${jugador}` ).toPromise();
  }
  getEfectividad(area: string, equipo: string, jugador: string, campania: string = null): Promise<any> {
    if(campania) {
      return this.http.get( `${DASHBOARD.ESTADISTICAS_EFECTIVIDAD}${area}/${equipo}/${jugador}/${campania}` ).toPromise();
    }
    return this.http.get( `${DASHBOARD.ESTADISTICAS_EFECTIVIDAD}${area}/${equipo}/${jugador}` ).toPromise();
  }
  getCategorias(area: string, equipo: string, jugador: string, campania: string = null ): Promise<any> {
    if(campania) {
      return this.http.get( `${DASHBOARD.ESTADISTICAS_CATEGORIAS}${area}/${equipo}/${jugador}/${campania}` ).toPromise();
    }
    return this.http.get( `${DASHBOARD.ESTADISTICAS_CATEGORIAS}${area}/${equipo}/${jugador}` ).toPromise();
  }
  getCopas(area: string, equipo: string, jugador: string): Promise<any> {
    return this.http.get( `${DASHBOARD.ESTADISTICAS_COPAS}${area}/${equipo}/${jugador}` ).toPromise();
  }

  getDashboard(area: string, equipo: string, jugador: string): Promise<any> {
    return this.http.get( `${DASHBOARD.ESTADISTICAS}${area}/${equipo}/${jugador}` ).toPromise();
  }

  detalleCategorias(area: string,  jugador: string, campaign: string): Promise<any> {
    if(campaign) {
      return this.http.get( `${DASHBOARD.CATEGORIAS}${area}/${jugador}/${campaign}` ).toPromise();
    }
    return this.http.get( `${DASHBOARD.CATEGORIAS}${area}/${jugador}` ).toPromise();
  }

  leaderboard(area: string,  jugador: string, campaign: string): Promise<any> {
    if(campaign) {
      return this.http.get( `${DASHBOARD.LEADERBOARD}${area}/${jugador}/${campaign}` ).toPromise();
    }
    return this.http.get( `${DASHBOARD.LEADERBOARD}${area}/${jugador}` ).toPromise();
  }

  masRetosJugados(area: string,  jugador: string, campaign: string): Promise<any> {
    if(campaign) {
      return this.http.get( `${DASHBOARD.MAS_RETOS_JUGADOS}${area}/${jugador}/${campaign}` ).toPromise();
    }
    return this.http.get( `${DASHBOARD.MAS_RETOS_JUGADOS}${area}/${jugador}` ).toPromise();
  }

  masRetosGanados(area: string,  jugador: string, campaign: string): Promise<any> {
    if(campaign) {
      return this.http.get( `${DASHBOARD.MAS_RETOS_GANADOS}${area}/${jugador}/${campaign}` ).toPromise();
    }
    return this.http.get( `${DASHBOARD.MAS_RETOS_GANADOS}${area}/${jugador}` ).toPromise();
  }

  masRetosPerdidos(area: string,  jugador: string, campaign: string): Promise<any> {
    if(campaign) {
      return this.http.get( `${DASHBOARD.MAS_RETOS_PERDIDOS}${area}/${jugador}/${campaign}` ).toPromise();
    }
    return this.http.get( `${DASHBOARD.MAS_RETOS_PERDIDOS}${area}/${jugador}` ).toPromise();
  }

  vs(area: string,  jugador: string, retador: string): Promise<any> {
    return this.http.get( `${DASHBOARD.VS}${area}/${jugador}/${retador}` ).toPromise();
  }

  detalleRonda(area: string,  jugador: string, retador: string, retoId: string = '-1'): Promise<any> {
    return this.http.get( `${DASHBOARD.DETALLE_RONDA}${area}/${jugador}/${retador}/${retoId}` ).toPromise();
  }

  getHistoricoRetos(area: string,  jugador: string, skip: number): Promise<any> {
    return this.http.get( `${DASHBOARD.HISTORIAL_RETOS}${area}/${jugador}/${skip}` ).toPromise();
  }

  existeHistoricoRetos(area: string,  jugador: string): Promise<any> {
    return this.http.get( `${DASHBOARD.EXISTE_HISTORIAL_RETOS}${area}/${jugador}` ).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/providers/dashboard/dashboard.ts